export function determineGeoLocation() {
	return fetch('//freegeoip.net/json/').then(response => {
		return response.json();
	});
}

// Overrides the following:
// https://github.com/facebook/react-devtools/blob/master/shells/chrome/src/checkForReact.js
export function enableReactDevTools(environments) {
	if (
		typeof window === 'object' &&
		window.__REACT_DEVTOOLS_GLOBAL_HOOK__ &&
		Object.keys(window.__REACT_DEVTOOLS_GLOBAL_HOOK__._renderers).length &&
		process.env.NODE_ENV === 'production' &&
		!environments.includes(process.env.REACT_APP_ENV)
	) {
		// do not load ReactDevTools
		window.__REACT_DEVTOOLS_GLOBAL_HOOK__._renderers = {};
		return false;
	} else {
		return true;
	}
}

export function enableReduxDevTools(environments) {
	return (
		typeof window === 'object' &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
		environments.includes(process.env.REACT_APP_ENV)
	);
}

export function copyTextToClipboard(text) {
	const temp = document.createElement("input");	// Create a "hidden" input
	temp.setAttribute("value", text); 					// Assign it the value of the specified element
	document.body.appendChild(temp);						// Append it to the body
	temp.select();												// Highlight its content
	document.execCommand("copy");							// Copy the highlighted text
	document.body.removeChild(temp); 					// Remove it from the body
}

export function copyElementToClipboard(elementId) {
	copyTextToClipboard(document.getElementById(elementId).innerHTML);
}

export function storageAvailable() {
	try {
		return 'localStorage' in window && window['localStorage'] !== null && 'sessionStorage' in window && window['sessionStorage'] !== null;
	} catch(e) {
		return false;
	}
}


// WEBPACK FOOTER //
// ./src/lib/utils.js